import React from 'react'
import Select from 'react-select'
import css from './style.css'

const ReactSelect = (props) => (
  <div className={css.selectRoot}>
    <Select
      multi={props.multi}
      clearable={props.clearable}
      options={props.options}
      value={props.value}
      onChange={props.onChange}
      disabled={props.disabled}
      matchPos={props.matchPos}
      matchProp={props.matchProp}
    />
  </div>
)

export default ReactSelect



// WEBPACK FOOTER //
// ./src/components/select/index.js